import React from 'react';
import SecondaryBudget from './SecondaryBudget';

// =============================================================================
// Distribution › Customer Delivery
//
// Depot to customer: the manufacturer / wholesaler side of secondary
// distribution. Same engine as Store Replenishment, but a separate page because
// the audiences do not overlap — an FMCG manufacturer has no stores, and a page
// you have to explain away is worse than a page that is not there.
//
// What is specific to this side: drops are usually ORDER-DRIVEN for the tail
// (independents order to a minimum drop size, so drops grow with the forecast)
// and SCHEDULE-driven for the big retail DCs on booked slots. The cost-to-serve
// output is the one that matters commercially — it feeds Revenue › Price
// Implosion and every customer-margin conversation.
// =============================================================================

const CustomerDelivery = () => (
  <SecondaryBudget
    kind="CUSTOMER"
    title="Customer Delivery"
    blurb="Depot to customer. Volume, drops, runs and km all derive from the zone and carrier setup — your job here is to disagree with them, not to type them."
    serveTitle="Cost to Serve"
    serveLabel="Customer"
    siteLabel="Origin Site (Depot)"
    storageKey="secondary-customer-delivery"
  />
);

export default CustomerDelivery;
